import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { quoteActions } from '../../store/quote-slice'

import classes from './AdditionalRequest.module.css'

const AdditionalRequest = () => {
  const dispatch = useDispatch()

  const extraBed = useSelector((state) => state.quote.extraBed)

 

  const extraBedChangeHandler = (event) => {
    dispatch(quoteActions.setExtraBedToggle())
  }

  const totalRooms = useSelector((state) => state.booking.totalRooms)
  const totalGuests = useSelector((state) => state.booking.totalGuests)

  const extraBedOption = totalRooms === 1 && totalGuests === 2

  if (extraBed && !extraBedOption) {
    dispatch(quoteActions.setExtraBedDisable())
  }

  return (
    <div className={classes.additionalContainer}>
      {extraBedOption && (
        <label className={classes.additionallabel}>
          <input
            className={classes.checkboxStyle}
            type="checkbox"
            checked={extraBed}
            onChange={extraBedChangeHandler}
          />
          &nbsp;Extra Bed Requested
        </label>
      )}
    </div>
  )
}

export default AdditionalRequest
